async function copyToClipboard(event) {
  try {
    event.preventDefault();
    
    const discountCodeEl = document.querySelector('.discount-code__code');
    const linkEl = document.querySelector('.discount-code__inner');
    
    if (!discountCodeEl || !linkEl) {
      console.error('Discount code or link element not found');
      return;
    }

    if (linkEl.href !== '') {
      window.open(linkEl.href, '_blank');
      return;
    }
    
    await navigator.clipboard.writeText(discountCodeEl.innerText);
    
    const wrapperEl = document.querySelector('.discount-code__wrapper');
    if (!wrapperEl) {
      console.error('Wrapper element not found');
      return;
    }
    
    wrapperEl.classList.add('active');
    setTimeout(() => {
      wrapperEl.classList.remove('active');
    }, 2000);
  } catch (error) {
    console.error('Failed to copy: ', error);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const copyButton = document.querySelector('.discount-code__inner');
  if (copyButton) {
    copyButton.addEventListener('click', copyToClipboard);
  } else {
    console.error('Copy button element not found');
  }
});